export class UsuarioAlteraSenha {
    id: number;
    senha: string;

    constructor(id: number) {
        this.id = id;
    }
}
